import { render, staticRenderFns } from "./tripslist.vue?vue&type=template&id=af941ff8&"
import script from "./tripslist.vue?vue&type=script&lang=js&"
export * from "./tripslist.vue?vue&type=script&lang=js&"
import style0 from "./tripslist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports